import isProduction from './isProduction'
import isServer from './isServer'

export function getRuntimeEnvironment() {
  if (isServer()) return
  if (!isProduction()) return 'local'
  const origin = window.location.origin
  if (origin.includes('-dev')) return 'development'
  if (origin.includes('-staging')) return 'staging'
  if (origin.includes('-qa')) return 'qa'
  return 'production'
}

export default getRuntimeEnvironment
